if(!customElements.get("finance-input-slider")) customElements.define("finance-input-slider", class extends HTMLElement {
    static get observedAttributes() {
        return ['value', 'min', 'max'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "value":
                if(newValue === null) {
                    newValue = this.min;
                }
                this.value = Number.parseFloat(newValue);
                this.updatePipkaPosition();
                break;
            case "min":
                this.min = newValue ? Number.parseFloat(newValue) : 0;
                this.updatePipkaPosition();
                break;
            case "max":
                this.max = newValue ? Number.parseFloat(newValue) : 0;
                this.updatePipkaPosition();
                break;
        }
    }

    connectedCallback() {
        const min = this.getAttribute('min');
        const max = this.getAttribute('max');
        const value = this.getAttribute('value');
        const step = this.getAttribute('step');
        this.min = min ? Number.parseFloat(min) : 0;
        this.max = max ? Number.parseFloat(max) : 100;
        this.value = value ? Number.parseFloat(value) : this.min;
        this.step = step ? Number.parseFloat(step) : 1;

        if (!this.querySelector('.pipka')) {
            document.addEventListener('DOMContentLoaded', this.onDOMContentLoaded.bind(this));
        } else {
            this.onDOMContentLoaded();
        }
    }

    onDOMContentLoaded() {
        var _this = this;
        this.pipka = this.querySelector('.pipka');
        this.pipkaRadius = this.pipka.getBoundingClientRect().width;

        this.updatePipkaPosition();

        this.addEventListener('click', function (e) {
            _this.movePipkaToClientX(e.clientX);
        });


        var down = false;

        const move = function (event) {
            if (down) {
                _this.movePipkaToClientX(event.clientX);
            }
        };
        const mdown = function (event) {

            _this.dispatchEvent(new CustomEvent('focus', {bubbles: true}));
            down = true;
            event.stopPropagation();
        };
        const up = function () {

            _this.dispatchEvent(new CustomEvent('blur', {bubbles: true}));
            down = false;
        };

        document.addEventListener('touchmove', (e) => move(e.touches[0]));
        document.addEventListener('mousemove', move);
        this.pipka.addEventListener('touchstart', (e) => mdown(e));
        this.pipka.addEventListener('mousedown', mdown);
        document.addEventListener('touchend', (e) => up(e));
        document.addEventListener('mouseup', up);

    }

    updatePipkaPosition() {
        if (this.pipka) {
            const rect = this.getBoundingClientRect();
            this.pipka.style.left = Math.min(rect.width - this.pipkaRadius,
                Math.max(0,
                    (rect.width - this.pipkaRadius) * (this.value - this.min) / (this.max - this.min)
                )
            ) + "px";
        }
    }

    movePipkaToClientX(clientX) {
        const rect = this.getBoundingClientRect();
        const xx = clientX - rect.x;
        const x = Math.min(rect.width - this.pipkaRadius / 2, Math.max(this.pipkaRadius / 2, xx));
        const xxx = x - this.pipkaRadius / 2;
        this.pipka.style.left = xxx + "px";
        const percent = xxx / (rect.width - this.pipkaRadius);
        const steps = Math.round((this.min + (percent) * (this.max - this.min)) / this.step);
        const newValue = Math.round(steps * this.step * 1000) / 1000;
        if(this.value !== newValue) {
            this.value = newValue;
            const customEvent = new CustomEvent('change', {bubbles: true});
            customEvent.value = newValue;
            this.dispatchEvent(customEvent);
            this.setAttribute('value', newValue);
        }
    }

});
